const config = {
  theme: "legacy",
};

export default config;
